export * from "./Floating";
import {
  useFloating,
  FloatingOverrideContext
} from "./useFloating";
export {
  FloatingOverrideContext,
  useFloating
};
//# sourceMappingURL=index.js.map
